import type { BoxProps } from "@braintrust/braintrust-ui-components";
import { Box, Typography } from "@braintrust/braintrust-ui-components";

import styles from "./style.module.scss";

type MessageWrapperProps = {
  children: React.ReactNode;
  sx?: BoxProps["sx"];
};

export const MessageWrapper = ({ children, sx }: MessageWrapperProps) => (
  <Box sx={sx} className={styles.locationWarningBadge}>
    🗣️ {children}
  </Box>
);

type CTAMessageProps = MessageWrapperProps & {
  onClick: () => void;
};

export const CTAMessage = ({ children, onClick }: CTAMessageProps) => {
  return (
    <Typography
      className={styles.locationWarningBadgeMessage}
      component="span"
      fontWeight={400}
      size="medium"
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      {children}
    </Typography>
  );
};
